// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1b2f326d","239":"4aaad34b","455":"16c487b7"}[chunkId] + ".chunk.js";
};